import * as React from "react";
const SvgFiBrandsVisualBasic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-visual-basic_svg__a)">
      <path d="M23.992 3.781a1.5 1.5 0 0 0-.841-1.19L18.206.21A1.5 1.5 0 0 0 16.5.5L8.527 9.314 3.875 5.5l-.408-.338A1 1 0 0 0 2.432 5l-1.817.75A1 1 0 0 0 0 6.668v10.665a1 1 0 0 0 .615.917l1.817.763a1 1 0 0 0 1.035-.163l.408-.35 4.652-3.815L16.5 23.5l.033.031c.45.422 1.113.526 1.672.26l4.945-2.38a1.5 1.5 0 0 0 .85-1.35V3.94a2 2 0 0 0-.008-.16M3 15.426V8.574L6.099 12zM11.803 12 18 6.92V17.08z" />
      <path d="m3.875 5.5-.408-.338A1 1 0 0 0 2.432 5a1 1 0 0 1 1.035.15zM23.992 20.22a1.5 1.5 0 0 1-.84 1.193l-4.946 2.377 4.945-2.38c.47-.227.785-.679.841-1.19M23.15 2.59 18.205.21l4.945 2.377c.472.227.787.68.841 1.193a1.5 1.5 0 0 0-.84-1.19" />
    </g>
    <defs>
      <clipPath id="fi-brands-visual-basic_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsVisualBasic;
